// Over the plan's seats (spec §5.5): a heads-up, never a block. Not
// dismissable — it goes away by itself when the count drops — and never shown
// offline, where the counts are whatever the last beat left behind.
import { usePresence } from "../presence/PresenceContext";
import { useOnline } from "../offline/useOnline";

export function SeatBanner(): JSX.Element | null {
  const counts = usePresence();
  const online = useOnline();
  if (!online || counts === null || !counts.over || counts.included === null) return null;
  return (
    <div
      role="status"
      className="vmc-seat-banner"
      style={{ background: "#fff3cd", color: "#5c4500", padding: "0.5rem 1rem", fontSize: 14 }}
    >
      Heads up: your team's got more people on Atlas right now than the {counts.included} seats your
      plan includes. Nobody's blocked, but time above that may be invoiced. Anyone who's done can
      sign out to free a seat.
    </div>
  );
}
